/**
 * Why a client wasn't opened for a new period — the backend's one-cycle-at-a-
 * time rule (`orchestrator.service.js#clientsInActiveCycle`), in words.
 */
const HELD_REASON = {
  ready: 'both ledgers in — about to be reconciled',
  reconciling: 'being reconciled right now',
  failed: 'last reconciliation failed — needs a look',
  needs_client_fix: 'waiting on their corrected statement',
  needs_our_fix: 'our fixes still open',
  needs_both_fix: 'fixes open on both sides',
  fixes_back: 'fixes in — being re-checked',
  cooldown: 'matched recently — next ask after the 30-day cooldown',
  collecting: 'their statement is in and being processed',
}

/** "3 held back: Anop Diamond (waiting on…), …" — or '' when nobody was. */
export function heldText(held = [], nameOf = (c) => c) {
  if (!held?.length) return ''
  const list = held.map((h) => `${nameOf(h.clientCode)} (${HELD_REASON[h.stage] ?? h.stage})`)
  const shown = list.slice(0, 6).join(', ')
  const more = list.length > 6 ? `, and ${list.length - 6} more` : ''
  return `${held.length} held back because their current cycle isn't finished: ${shown}${more}.`
}
